/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AgGrid from 'DesignSystem/AgGrid/react'
import FilterBy from './FilterBy/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content",
  height,
  columnDefs,
  rowData,
  masterDetail,
  detailCellRenderer,
  detailRowAutoHeight,
  onRowClicked,
  getRowStyle
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--btc-6-Z1Yf8zk': dtColorsNeutral200,'--bc-5-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 disableAutoSizeStrategy={true}
 height={height}
 headerHeight={36}
 rowHeight={32}
 rowGroupPanelShow="never"
 verticalBorders={true}
 overlayNoRowsTemplate="No invoices found"
 columnDefs={columnDefs}
 rowData={rowData}
 suppressCellFocus={true}
 masterDetail={masterDetail}
 detailCellRenderer={detailCellRenderer}
 detailRowAutoHeight={detailRowAutoHeight}
 onRowClicked={onRowClicked}
 getRowStyle={getRowStyle}
/>
</div>
</div>
<FilterBy
  viewPath={`${viewPath}/FilterBy`}
/>
{children}
</React.Fragment>)
}